import React from 'react';
import { observer } from 'mobx-react';
import moment from 'moment';
import { CheckboxInput, TextDefault } from '@awarego-ui/components';
import BounceReasonCell, {
    bounceReasonSort,
    humanizeEmailType,
} from './BounceReasonCell';
import NameAndSublistCell from '../../../components/manager/NameAndSublistCell';
import { caseAndDiacriticsInsensitiveSort } from '../../../components/table/table-helpers';

function isRowSelected(store, email) {
    if (store.selection.allSelected) {
        return !store.selection.unChecked[email];
    }
    return !!store.selection.checked[email];
}

function formatLastAttempt(value, attempts) {
    if (!value) return '—';
    const m = moment(value);
    const when = m.isValid() ? m.format('ll HH:mm') : String(value);
    if (attempts != null && attempts !== '' && !Number.isNaN(Number(attempts))) {
        return `${when} · ${attempts}×`;
    }
    return when;
}

export function bouncedEmailColumns(store) {
    const rows = (store && store.usersList) || [];
    const showEmailType = rows.some((r) => r && r.emailType);

    const columns = [
        {
            Header: 'Name',
            id: 'name',
            accessor: (x) => {
                return x.name || x.email;
            },
            sortType: caseAndDiacriticsInsensitiveSort,
            Cell: observer((x) => {
                const email = x.row.original.email;
                return (
                    <CheckboxInput
                        label={x.value}
                        checked={isRowSelected(store, email)}
                        noYPadding={true}
                        onChange={(e) => {
                            store.selection.toggleRow(
                                x.row.original,
                                e.target.checked
                            );
                        }}
                    />
                );
            }),
        },
        {
            Header: 'List',
            accessor: 'lists_names',
            Cell: (x) => {
                if (x.value && x.value.length > 0) {
                    return (
                        <NameAndSublistCell
                            subListItems={x.value}
                            maxVisibleSubListCount={1}
                        ></NameAndSublistCell>
                    );
                }
                return <TextDefault lighter>List unavailable</TextDefault>;
            },
        },
        {
            Header: 'Email',
            accessor: 'email',
        },
        {
            Header: 'Bounce reason',
            id: 'bounceReason',
            accessor: (row) => {
                const code = row.code || (row.reason && row.reason.code) || '';
                const message =
                    (row.reason && (row.reason.message || row.reason.type)) ||
                    '';
                return `${code} ${message}`.trim();
            },
            sortType: bounceReasonSort,
            Cell: (x) => (
                <BounceReasonCell
                    reason={x.row.original.reason}
                    code={x.row.original.code}
                    bounceKind={x.row.original.bounceKind}
                />
            ),
        },
        {
            Header: 'Last attempt',
            id: 'lastAttemptAt',
            accessor: 'lastAttemptAt',
            Cell: (x) => (
                <TextDefault>
                    {formatLastAttempt(
                        x.value,
                        x.row.original.attempts
                    )}
                </TextDefault>
            ),
        },
    ];

    if (showEmailType) {
        columns.push({
            Header: 'Email type',
            accessor: 'emailType',
            Cell: (x) =>
                x.value ? (
                    <TextDefault>{humanizeEmailType(x.value)}</TextDefault>
                ) : (
                    <TextDefault lighter>—</TextDefault>
                ),
        });
    }

    return columns;
}
